
function addToClickedFilters(value, clickedFilters) {
    let modifiedClickedFilters = [...clickedFilters];
    if (!modifiedClickedFilters.includes(value)) {
        modifiedClickedFilters.push(value);
    } else {
        modifiedClickedFilters = modifiedClickedFilters.filter(f => f !== value);
    }
    return modifiedClickedFilters;
}

function fillInitialClickedFilters(filterOptions) {
    const filledClickedFilters = [];
    filterOptions?.map((option) => {
        if (option.selected) {
            filledClickedFilters.push(option.value);
        }
    });
    return filledClickedFilters;
}

export {addToClickedFilters, fillInitialClickedFilters};
